import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Grid,
  Box,
  Button,
} from "@mui/material";
import { Link } from "react-router-dom";
import './Products.css';
const Products = () => {
  const [products, setProducts] = useState([]); // Ensure it's initialized as an empty array
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [viewAll, setViewAll] = useState(false); // State to toggle "View All"

 useEffect(() => {
  const fetchProducts = async () => {
    try {
      const response = await axios.get(
        "https://agpipefitting.org.et/api/product_descriptions"
      );

      console.log("FULL RESPONSE:", response.data);

      const productArray = Array.isArray(response.data)
        ? response.data
        : Array.isArray(response.data.data)
        ? response.data.data
        : [];

      if (productArray.length > 0) {
        const sortedProducts = productArray.sort((a, b) => b.id - a.id);
        setProducts(sortedProducts);
      } else {
        setError("No products found or wrong API format.");
      }
    } catch (err) {
      console.error("FETCH ERROR:", err.response || err.message);
      setError(
        err.response?.data?.message ||
        err.message ||
        "Failed to fetch products."
      );
    } finally {
      setLoading(false);
    }
  };

  fetchProducts();
}, []);

  
  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="50vh"
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="50vh"
      >
        <Typography color="error" variant="h6">
          {error}
        </Typography>
      </Box>
    );
  }

  // Safeguard to ensure products is always an array before applying slice
  const productsToShow = products && products.length > 0 ? (viewAll ? products : products.slice(0, 8)) : [];

  return (
    <section id="products" className="py-5" style={{ backgroundColor: '#ccdae8' }}>
      <Box py={5}>
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{
            fontWeight: "bold",
            background: "linear-gradient(90deg, #4A90E2, #50C878)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            textTransform: "uppercase",
            letterSpacing: 2,
            mb: 4,
          }}
        >
          Explore Our Products
        </Typography>

        <Grid container spacing={4}>
          {productsToShow.map((product) => (
            <Grid item xs={12} sm={6} md={3} key={product.id}>
              <Link
                to={`/products/${product.id}`}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <Card
                  sx={{
                    borderRadius: "15px",
                    boxShadow: "0px 8px 16px rgba(0,0,0,0.1)",
                    "&:hover": {
                      transform: "scale(1.05)",
                      boxShadow: "0px 12px 24px rgba(0,0,0,0.2)",
                    },
                    overflow: "hidden",
                  }}
                >
                  {product.image && (
                    <CardMedia
                      component="img"
                      image={`https://agpipefitting.org.et/storage/${product.image}`}
                     
                      sx={{
                        height: 200,
                        objectFit: "cover",
                        filter: "brightness(0.95)",
                      }}
                    />
                  )}
                  <CardContent>
                    <Typography
                      variant="h6"
                      component="div"
                      sx={{ fontWeight: "bold", color: "#111" }}
                    >
                      {product.type}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mt: 1, mb: 1.5 }}
                    >
                     
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "primary.main",
                        fontWeight: "500",
                        textTransform: "capitalize",
                      }}
                    >
                      {product.quantity} in stock
                    </Typography>
                  </CardContent>
                </Card>
              </Link>
            </Grid>
          ))}
        </Grid>

        {!viewAll && (
         <Box display="flex" justifyContent="center" mt={4}>
         <Button
           variant="contained"
           color="primary"
           onClick={() => {
             window.open('/all-products', '_blank'); // Opens the products page in a new tab
           }}
         >
           View All
         </Button>
       </Box>
       
        )}
      </Box>
    </section>
  );
};

export default Products;
